module.exports = __webpack_public_path__ + "static/media/odin.870a7be0.png";